import React, { useState } from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import VisitorDetailsModal from '../../Modals/VisitorDetailsModal/VisitorDetailsModal';

function VisitorListItem(props) {
    const { t } = useTranslation();
    const { visitor, eventID } = props;
    const getTime = (seconds) => moment().startOf('day').seconds(seconds).format('HH:mm:ss');
    const [showDetails, setShowDetails] = useState(false);

    return (
        <>
            <div
                className="DataListItem row align-items-center"
                style={{paddingTop: '20px', paddingBottom: '20px', cursor: 'pointer'}}
                onClick={() => setShowDetails(true)}
            >
                <div className="col-lg-2">
                    <span>
                        {(visitor.firstName.length || visitor.lastName.length)
                            ? <strong>{visitor.firstName} {visitor.lastName}</strong>
                            : <strong>{t('analytics.anonymous_visitor')}</strong>
                        }
					</span>
                </div>
                <div className="col-lg-2 text-left">
                    {visitor.company || ''}
                </div>
                <div className="col-lg-2 text-left">
                    {visitor.jobTitle || ''}
                </div>
                <div className="col-lg-2 text-left">
                   {visitor.timeCreated ? <>
                        <p className="text-muted">{t('analytics.first_seen')}</p>
                        {moment(visitor.timeCreated).format('DD.MM.YYYY HH:mm') + ' UTC' || ''}
                    </> : null}
                </div>
                <div className="col-lg-2 text-left">
                    {visitor.timeLatestActivity ?
                        <>
                            <p className="text-muted">{t('analytics.latest_activity')}</p>
                            {visitor.timeLatestActivity ? moment(visitor.timeLatestActivity).format('DD.MM.YYYY HH:mm') + ' UTC' : ''}
                        </>
                    : null}
                </div>
                <div className="col-lg-2 text-left">
                    {visitor.activityTime ?
                        <>
                            <p className="text-muted">{t('analytics.activity_time')}</p>
                            <>{getTime(visitor.activityTime)}</>
                        </>
                    : null}
                </div>
            </div>

            {showDetails ?
                <VisitorDetailsModal
                    visitor={visitor}
                    onClose={() => setShowDetails(false)}
                    eventID={eventID}
                />
            : null}
        </>
    )
}

export default VisitorListItem;